/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { fetchUserDashboardConversations } from '../../store/actions/conversationActions';
import { CONVERSATION_CONTROL_TABS } from '../../utils/constants'
import { simpleGTMDataLayer } from '../../utils/utilities';
import AdjusterSearch from '../adjusterSearch/AdjusterSearch';
import DashBoardConversations from '../dashBoardConversations/DashBoardConversations';

const Container = styled.div`
    margin:25px;
    margin-top: 15px;
`;

export default function AllConversations() {
    const [isfilter, setFilter] = useState<boolean>(false);
    const [isSort, setSortFlag] = useState<boolean>(true);
    const [filterDD, setFilterDD] = useState<string>('Display Range');
    const [conversations, setConversations] = useState<any>([]);
    const [step, setStep] = useState(0);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(0);
    const [date, setDate] = useState(undefined);
    const [selectedAdjuster, setSelectedAdjuster] = useState<any>(null);
    const [isLoading, setLoading] = useState(false);
    const user = useSelector((state: any) => state.user)

    useEffect(() => {
        simpleGTMDataLayer({
            csrId: user.userName,
            event: 'pageview',
            page: {
                path: '/conversation-control',
                title: 'Claims Texting: All Conversations Page'
            }
        });
    }, []);

    useEffect(() => {
        handleSearch();
    }, [page, selectedAdjuster,isSort]);

    useEffect(() => {
        if (isfilter === false)
            handleSearch();
    }, [isfilter]);

    useEffect(() => {
        if (date !== undefined)
            handleSearch();
    }, [date])



    const handleSearch = () => {
        // if (conversations.length >= page * 2 + 2 || (conversations.length === count && count !== 0 && isfilter !== true)) {
        //     return;
        // }
        if (selectedAdjuster) {
            setLoading(true);
            fetchUserDashboardConversations({ adjusterId: selectedAdjuster?.adjusterEmailId, index: page, limit: 100, filter: isfilter, date: date, sortFlag:isSort }, (res: any) => {
                // setConversations([...conversations, ...res.myConversations]);
                setConversations([...res.myConversations]);
                setCount(res.count)
                setLoading(false);
            }, (error: any) => {
                setLoading(false);
            });
            setStep(1);
        }
    }

    const handleCancel = () => {
        setStep(0);
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `New-Adjuster-Search-Click`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `New adjuster Search for all conversations`,
            event_value: `${user.fullName} was requesting for new adjuster search`
        });

        simpleGTMDataLayer({
            csrId: user.userName,
            event: `New-Adjuster-Search-Click-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `New adjuster Search for all conversations`,
            event_value: `${user.fullName} was requesting for new adjuster search`
        });
    }


    const updateAdjuster = (adjuster: any) => {
        setConversationsEmpty();
        setSelectedAdjuster(adjuster);
    }

    const updatePage = (page: any) => {
        setPage(page);
    }

    const updateCount = (page: any) => {
        setCount(page);
    }

    const setConversationsEmpty = () => {
        setConversations([]);
        setPage(0);
        setCount(0);
        setDate(undefined);
        setSortFlag(true);
    }

    const getFilterData = (value: any) => {
        //filterdate = value;
        setDate(value);
        //handleSearch();
    }

    const getComponent = () => {
        switch (step) {
            case 0:
                return <AdjusterSearch
                    selectedType={CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS}
                    updateAdjuster={updateAdjuster}
                    setConversationsEmpty={setConversationsEmpty}
                    setFilter={setFilter}
                />;
            case 1:
                return <DashBoardConversations
                    selectedAdjuster={selectedAdjuster}
                    conversations={conversations}//.slice(page * 2, page * 2 + 2)}
                    selectedType={CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS}
                    handleCancel={handleCancel}
                    updatePage={updatePage}
                    updateCount={updateCount}
                    totalCount={count}
                    page={page}
                    setConversationsEmpty={setConversationsEmpty}
                    getFilterInput={getFilterData}
                    isfilter={isfilter}
                    setFilter={setFilter}
                    filterDD={filterDD}
                    setFilterDD={setFilterDD}
                    sortFlag={isSort}
                    setSortFlag={setSortFlag}
                />
            default:
                return <AdjusterSearch
                    selectedType={CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS}
                    handleSearch={handleSearch}
                />;
        }
    }

    return (
        <Container data-testid="all-conversations">
            {isLoading ?
                <div className="loader" /> :
                getComponent()
            }
        </Container>
    )
}
